import axios from 'axios'
import library from '../../../utils/Library'

export const unassignUserSubscriberCorpEntity = async (data) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('subscribers') + '/unassignUserSubscriberCorpEntity'

  return await axios({
    url: URL,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      subscriber_id: data.subscriber_id,
      user_id: data.user_id
    }
  })
}
